import React, { useEffect, useState, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "../shared/Spinner";
import "../../assets/styles/style.css";
import { useNavigate } from "react-router-dom";
import UserServices from "../services/externalServices/userServices";
import { DataGrid } from "@mui/x-data-grid";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import SvgIcon from "@mui/material/SvgIcon";
import {
  Tabs,
  Tab,
  Typography,
  Box,
  Paper,
  Avatar,
  Grid,
  Chip,
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Stack,
  Divider,
  Rating,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  CircularProgress,
} from "@mui/material";

import { Edit, Delete } from "@mui/icons-material";
import { Add as AddIcon } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CabRequestDetails from "./CabRequestDetails";


import TheatreServices from "../services/externalServices/TicketServices/theatreServices";

// import '../../assets/styles/stlyle.css'
function UserProfile() {
  const { id } = useParams(); // Get the userId from the URL parameter
  const navigate = useNavigate();
  // console.log("id",id);
  const [userDetails, setUserDetails] = useState(null); // State to store user details
  const [editedUser, setEditedUser] = useState({});
  const [updatedUser, setUpdatedUser] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [render, setRender] = useState(null);
  const [userTripDetails, setUserTripDetails] = useState([]);
  const [completedTrips, setCompletedTrips] = useState();
  const [cancelledTrips, setCancelledTrips] = useState();
  const [upcomingTrips, setUpcomingTrips] = useState();
  const [open, setOpen] = useState(false);
  const [earnings, setEarnings] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const [bookingHistory, setBookingHistory] = useState(null);
  const [bookingLoading, setBookingLoading] = useState(false);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bookingFilter, setBookingFilter] = useState("COMPLETED");




  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const handleTabChange = (event, newValue) => {
  //   setActiveTab(newValue);
  // };



  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    // Booking History tab index = 4
    if (newValue === 4 && !bookingHistory) {
      fetchBookingHistory();
    }
  };








  const fetchBookingHistory = async () => {
    try {
      setBookingLoading(true);
      // const phoneNumber = userDetails?.phone_number;

      const rawPhone = userDetails?.phone_number;
      if (!rawPhone) return;

      // convert to string + clean
      const phoneStr = String(rawPhone).replace(/\s+/g, "");

      // add +91 only if missing
      const phoneNumber = phoneStr.startsWith("91")
        ? phoneStr
        : `91${phoneStr}`;
      console.log('in the user prfile  booking history====', phoneNumber)
      if (!phoneNumber) return;


      

      // const response = await axios.get(
      //   `https://preprodticket.wmdservices.asia/api/bookings/getHistoryByUserId/${phoneNumber}`
      // );

      // console.log('response of booking', response);



      const response = await TheatreServices.getHistoryByUserId(phoneNumber);

    console.log("response of booking", response);

      setBookingHistory(response.data);






    } catch (error) {
      console.error("Error fetching booking history", error);
    } finally {
      setBookingLoading(false);
    }
  };





  const fetchData = async () => {
    try {
      // const response = await axios.get(`http://localhost:8080/users/${id}`);
      const response = await UserServices.getUserById(id);

      setUserDetails(response);
      setEditedUser(response);
      setUpdatedUser(response);
      console.log("fetching user is working", response);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };
  // Fetch user details based on userId using useEffect
  useEffect(() => {
    fetchData();

    // usersDetails();
  }, [render]);
  useEffect(() => {
    usersTrips();

    // usersDetails();
  }, []);

  const usersTrips = async (req, res) => {
    try {
      console.log("Fetching user trip details for ID:", id);

      const trips = await UserServices.getUserTripDetails(id);
      setUserTripDetails(trips[0].trips);
      const completedTrips = trips[0].trips.filter(
        (trip) => trip.status === "TRIP_ENDED"
      );
      const cancelledTrips = trips[0].trips.filter(
        (trip) => trip.status === "CANCELLED"
      );
      const upcomingTrips = trips[0].trips.filter(
        (trip) => trip.status === "BOOKED"
      );
      setUpcomingTrips(upcomingTrips.length);
      console.log("completedTrips", completedTrips);
      setCompletedTrips(completedTrips.length);
      setCancelledTrips(cancelledTrips.length);
      console.log("userTripDetails", trips);
    } catch (error) {
      console.log("error while fetching userTrip Details", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUpdatedUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    // setRender(true);
    console.log("HandleSave buton is clicked");
    console.log(updatedUser);
    console.log(id, "id");
    // axios
    //   .put(`http://localhost:8080/users/${id}`, updatedUser)

    await UserServices.updateUser(id, updatedUser)
      .then((response) => {
        console.log("User data updated successfully:", response);
        setRender(true);
        handleClose();
        // You can redirect or display a success message here
        // const updatedUserData = JSON.parse(localStorage.getItem("users"));
        // const updatedUserDataIndex = updatedUserData.findIndex(
        //   (user) => user.id === parseInt(id)
        // );

        // if (updatedUserDataIndex !== -1) {
        //   updatedUserData[updatedUserDataIndex] = updatedUser;
        //   localStorage.setItem("users", JSON.stringify(updatedUserData));
        // }
        // window.location.reload();
        // navigate(`/users/${id}`);
      })
      .catch((error) => {
        console.error("Error updating user data:", error);
        // Display an error message here
      })
      .finally(() => {
        setIsSaving(false); // Set isSaving to false when the request is complete
      });
  };

  const formatDDMMYYYY = (date) => {
    // const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
    const options = {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const formattedDate = new Date(date);
    return formattedDate.toLocaleString("en-GB", options);
  };

  // displaying the Trips Colums and rows

  const columns = [
    { field: "amount", headerName: "Amount", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        let label, color;

        switch (params.value) {
          case "TRIP_ENDED":
            label = "Completed";
            color = "success";
            break;
          case "CANCELLED":
            label = "Cancelled";
            color = "error";
            break;
          case "TRIP_STARTED":
            label = "In Progress";
            color = "info";
            break;
          case "ON_THE_WAY":
            label = "On the Way";
            color = "primary";
            break;
          case "BOOKED":
            label = "Booked";
            color = "primary";
            break;
          default:
            label = "Pending";
            color = "warning";
            break;
        }

        return <Chip label={label} color={color} variant="soft" size="small" />;
      },
    },
    {
      field: "tripid",
      headerName: "TripID",
      flex: 1,
      renderCell: (params) => {
        const tripId = params.value;
        return <Link to={`/trip/${tripId}`}>{tripId}</Link>;
      },
    },
    {
      field: "trip_start_time",
      headerName: "Date",
      flex: 1,
      // valueGetter: (params) => formatDate(params.value),
    },
  ];

  const rows = userTripDetails.map((trip, index) => ({
    id: index, // Unique row ID
    amount: trip.bid ? `$${trip.bid.amount}` : "N/A",
    status: trip.status,
    tripid: trip._id,
    trip_start_time: trip.trip_start_time,
  }));

  // Render the user details




  // UseMemo so that we no need to sort on every render


  const filteredSortedBookings = useMemo(() => {
    if (!bookingHistory) return [];
  
    const allBookings = [
      ...(bookingHistory.upcoming || []),
      ...(bookingHistory.history || []),
    ];
  
    return [...allBookings]
      .filter(item => item.payment?.transactionStatus === bookingFilter)
      .sort((a, b) => new Date(b.bookingDate) - new Date(a.bookingDate));
  }, [bookingHistory, bookingFilter]);
  

  return (
    <Paper elevation={3} sx={{ borderRadius: "16px", padding: 2 }}>
      {userDetails && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Link
                  to="/users"
                  underline="hover"
                  variant="subtitle2"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5em"
                    height="1.5em"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                    fontSize="var(--icon-fontSize-md)"
                  >
                    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                  </svg>
                </Link>
              </Grid>
              <Grid item>
                <Link
                  to="/users"
                  underline="hover"
                  variant="subtitle2"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Typography variant="subtitle2">Users</Typography>
                </Link>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Avatar
                  src="/assets/avatar-1.png"
                  sx={{ width: 70, height: 70 }}
                />
              </Grid>
              <Grid item>
                <Typography variant="h4">
                  {userDetails.first_name} {userDetails.last_name}
                </Typography>
                <Chip
                  label="Active"
                  color="success"
                  variant="outlined"
                  size="small"
                />
                <Typography variant="body1" color="#667085">
                  {userDetails.email_id}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center", // Centers horizontally
              alignItems: "center", // Centers vertically
              height: "100%", // Optional: Ensures alignment within parent container
            }}
          >
            <Tabs value={activeTab} onChange={handleTabChange} centered>
              <Tab label="Basic Details" />
              <Tab label="Trips" />
              <Tab label="Account Actions" />
              <Tab label="Cab Requests" />
              <Tab label="Booking History" />
            </Tabs>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={12}>
                <TabPanel value={activeTab} index={0}>
                  <Card elevation={2} sx={{ borderRadius: "16px" }}>
                    <CardHeader
                      avatar={
                        <Paper
                          elevation={3}
                          style={{
                            backgroundColor: "white",
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Avatar style={{ backgroundColor: "white" }}>
                            {/* <GroupIcon fontSize="large" /> */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="1em"
                              height="1em"
                              fill="black"
                              viewBox="0 0 256 256"
                              font-size="var(--icon-fontSize-lg)"
                            >
                              <path d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"></path>
                            </svg>
                            {/* <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10.1992 12C12.9606 12 15.1992 9.76142 15.1992 7C15.1992 4.23858 12.9606 2 10.1992 2C7.43779 2 5.19922 4.23858 5.19922 7C5.19922 9.76142 7.43779 12 10.1992 12Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M1 22C1.57038 20.0332 2.74795 18.2971 4.36438 17.0399C5.98081 15.7827 7.95335 15.0687 10 15C14.12 15 17.63 17.91 19 22" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.8205 4.44006C18.5822 4.83059 19.1986 5.45518 19.579 6.22205C19.9594 6.98891 20.0838 7.85753 19.9338 8.70032C19.7838 9.5431 19.3674 10.3155 18.7458 10.9041C18.1243 11.4926 17.3302 11.8662 16.4805 11.97" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.3203 14.5701C18.6543 14.91 19.8779 15.5883 20.8729 16.5396C21.868 17.4908 22.6007 18.6827 23.0003 20" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg> */}
                          </Avatar>
                        </Paper>
                      }
                      action={
                        <IconButton onClick={handleClickOpen}>
                          <Edit />
                        </IconButton>
                      }
                      title={
                        <Typography variant="h6" color="#667085">
                          Basic details
                        </Typography>
                      }
                    />
                    <CardContent>
                      {/* Card Content */}
                      <Box mb={2}>
                        <Typography variant="body2" color="#667085">
                          User ID
                        </Typography>
                        <Chip
                          label={userDetails._id}
                          style={{ backgroundColor: "#f0f4f8", color: "#000" }}
                          size="small"
                        />
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Name
                        </Typography>
                        <Typography variant="subtitle2">
                          {userDetails.first_name} {userDetails.last_name}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Email
                        </Typography>
                        <Typography variant="subtitle2">
                          {userDetails.email_id}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Phone
                        </Typography>
                        <Typography variant="subtitle2">
                          {userDetails.phone_number}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Emergency Contact
                        </Typography>
                        <Typography variant="subtitle2">
                          {userDetails.emergency_contact}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Follow Up
                        </Typography>
                        <Typography variant="subtitle2">
                          {userDetails.internalComments}
                        </Typography>
                      </Box>
                      <Divider />
                      <Box mb={2} mt={2}>
                        <Typography variant="body2" color="#667085">
                          Rating
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Rating
                            name="read-only"
                            value={userDetails.rating}
                            precision={0.5}
                          />
                          <Typography variant="body2">{`${userDetails.rating * 20
                            }%`}</Typography>
                        </Stack>
                      </Box>
                    </CardContent>
                  </Card>
                  <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>
                      Edit Details
                      <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent style={{ marginTop: "4px" }}>
                      <form>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="id"
                              type="text"
                              label="ID"
                              value={updatedUser._id || ""}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="first_name"
                              type="text"
                              label="First Name"
                              defaultValue={updatedUser.first_name || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="last_name"
                              type="text"
                              label="Last Name"
                              defaultValue={updatedUser.last_name || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="phone_number"
                              type="text"
                              label="Phone Number"
                              defaultValue={updatedUser.phone_number || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="password"
                              type="text"
                              label="Password"
                              defaultValue={updatedUser.password || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="email_id"
                              type="text"
                              label="Email-Id"
                              defaultValue={updatedUser.email_id || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="avatar_url"
                              type="text"
                              label="Avatar Url"
                              defaultValue={updatedUser.avatar_url || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="rating"
                              type="text"
                              label="Rating"
                              defaultValue={updatedUser.rating || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="internalComments"
                              type="text"
                              label="Follow Up"
                              defaultValue={updatedUser.internalComments || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <FormControl fullWidth variant="outlined">
                              <InputLabel id="single-device-login-label">
                                Single Device Login
                              </InputLabel>
                              <Select
                                labelId="single-device-login-label"
                                id="single-device-login"
                                name="is_active"
                                value={updatedUser.is_active || ""}
                                onChange={handleInputChange}
                                label="Single Device Login"
                              >
                                <MenuItem value={true}>True</MenuItem>
                                <MenuItem value={false}>False</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          {/* <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="is_new_user"
                              type="text"
                              label="New User"
                              defaultValue={updatedUser.is_new_user || ""}
                              onChange={handleInputChange}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              name="is_user"
                              type="text"
                              label="User"
                              defaultValue={updatedUser.is_user || ""}
                              onChange={handleInputChange}
                            />
                          </Grid> */}
                        </Grid>
                        <div className="text-center mt-4">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSave}
                            disabled={isSaving}
                          >
                            {isSaving ? (
                              <CircularProgress size={24} />
                            ) : (
                              "Save Changes"
                            )}
                          </Button>
                        </div>
                      </form>
                    </DialogContent>
                  </Dialog>
                  {/* </Grid> */}
                  {/* <Grid  item xs={12}> */}
                  {/* <Card
                    elevation={2}
                    style={{ borderRadius: "16px", marginTop: "8px" }}
                  >
                    <CardContent>
                    
                      <Stack spacing={2}>
                        <Button
                          variant="contained"
                          color="error"
                          startIcon={<Delete />}
                        >
                          Delete account
                        </Button>
                        <Typography variant="body2">
                          A deleted customer cannot be restored. All data will
                          be permanently removed.
                        </Typography>
                      </Stack>
                    </CardContent>
                  </Card> */}
                </TabPanel>
              </Grid>

              <Grid item xs={12} md={12}>
                <TabPanel value={activeTab} index={1}>
                  <Card elevation={2} sx={{ borderRadius: "16px" }}>
                    <CardHeader
                      avatar={
                        <Paper
                          elevation={3}
                          style={{
                            backgroundColor: "white",
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Avatar style={{ backgroundColor: "white" }}>
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                {" "}
                                <path
                                  d="M8.57385 20.3523L11.9553 13.5894C11.9737 13.5526 12.0263 13.5526 12.0447 13.5894L15.4261 20.3523C15.4483 20.3965 15.3996 20.4426 15.3566 20.4181L12.0248 18.5142C12.0094 18.5054 11.9906 18.5054 11.9752 18.5142L8.64338 20.4181C8.60043 20.4426 8.55173 20.3965 8.57385 20.3523Z"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                                <path
                                  d="M20.5 18.5L16.5 3.5"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                                <path
                                  d="M3.5 18.5L7.5 3.5"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                                <path
                                  d="M12 10.5V8.5"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                                <path
                                  d="M12 5.5V3.5"
                                  stroke="#33363F"
                                  stroke-linecap="round"
                                ></path>{" "}
                              </g>
                            </svg>
                          </Avatar>
                        </Paper>
                      }
                      title={
                        <Typography variant="h6" color="#667085">
                          Trips
                        </Typography>
                      }
                    />
                    {userTripDetails.length >= 1 ? (
                      <CardContent>
                        <Stack
                          direction="column"
                          spacing={2}
                          justifyContent="space-between"
                        >
                          <Paper variant="outlined" sx={{ padding: 2 }}>
                            <Stack
                              direction="row"
                              spacing={2}
                              justifyContent="space-between"
                            >
                              <div>
                                <Typography variant="overline" color="#667085">
                                  Total trips
                                </Typography>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography variant="h6">
                                    {userTripDetails.length}
                                  </Typography>
                                </div>
                              </div>
                              <Divider orientation="vertical" flexItem />
                              <div>
                                <Typography variant="overline" color="#667085">
                                  Completed Trips
                                </Typography>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography variant="h6">
                                    {completedTrips}
                                  </Typography>
                                </div>
                              </div>
                              <Divider orientation="vertical" flexItem />
                              <div>
                                <Typography variant="overline" color="#667085">
                                  Cancelled Trips
                                </Typography>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography variant="h6">
                                    {cancelledTrips}
                                  </Typography>
                                </div>
                              </div>
                              <Divider orientation="vertical" flexItem />
                              <div>
                                <Typography variant="overline" color="#667085">
                                  Upcoming Trips
                                </Typography>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography variant="h6">
                                    {upcomingTrips}
                                  </Typography>
                                </div>
                              </div>
                            </Stack>
                          </Paper>
                          <Paper
                            variant="outlined"
                            sx={{ padding: 2, flexGrow: 1 }}
                          >
                            <div style={{ height: 400, width: "100%" }}>
                              <DataGrid
                                rows={rows}
                                columns={columns}
                                pageSize={5}
                                rowsPerPageOptions={[5]}
                              />
                            </div>
                          </Paper>
                        </Stack>
                      </CardContent>
                    ) : (
                      <CardContent>
                        <Stack
                          direction="column"
                          spacing={2}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="h6" color="textSecondary">
                            No trips available
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            You currently have no trip history to display.
                          </Typography>
                        </Stack>
                      </CardContent>
                    )}
                  </Card>
                </TabPanel>
              </Grid>

              <Grid item xs={12} md={12}>
                <TabPanel value={activeTab} index={3}>
                  <CabRequestDetails id={id} />
                </TabPanel>
              </Grid>





              <Grid item xs={12} md={12}>
                <TabPanel value={activeTab} index={4}>
                  <Card elevation={2} sx={{ borderRadius: "16px" }}>
                    <CardHeader
                      title={
                        <Typography variant="h6" color="#667085">
                          Booking History
                        </Typography>
                      }
                    />

                    <Stack direction="row" spacing={2} mb={3}>
                      <Chip
                        label="Completed"
                        color={bookingFilter === "COMPLETED" ? "success" : "default"}
                        onClick={() => setBookingFilter("COMPLETED")}
                      />
                      <Chip
                        label="Pending"
                        color={bookingFilter === "PENDING" ? "warning" : "default"}
                        onClick={() => setBookingFilter("PENDING")}
                      />
                      <Chip
                        label="Failed"
                        color={bookingFilter === "FAILED" ? "error" : "default"}
                        onClick={() => setBookingFilter("FAILED")}
                      />
                    </Stack>


                    <CardContent>
                      {bookingLoading && <CircularProgress />}

                   



{/* {!bookingLoading && bookingHistory && (
  <>
    <Typography variant="subtitle1" gutterBottom>
      Bookings ({bookingFilter})
    </Typography>

    {(() => {
      // Combine upcoming + history
      const allBookings = [
        ...(bookingHistory.upcoming || []),
        ...(bookingHistory.history || []),
      ];

      // Filter by payment status
      const filteredBookings = allBookings.filter(
        item => item.payment?.transactionStatus === bookingFilter
      );

      // Sort by booking date (latest first)
      const sortedBookings = filteredBookings.sort(
        (a, b) => new Date(b.bookingDate) - new Date(a.bookingDate)
      );

      return sortedBookings.length ? (
        sortedBookings.map(item => (
          <Paper key={item._id} sx={{ p: 2, mb: 2 }}>
            <Typography variant="subtitle2">{item.movieName}</Typography>
            <Typography variant="body2">
              {item.showDate} • {item.showTime}
            </Typography>
            <Typography variant="body2">{item.theatreName}</Typography>
            <Typography variant="body2">
              Amount: ₹{item.payment?.totalAmount || 0}
            </Typography>
            <Chip
              label={item.payment?.transactionStatus}
              color={
                item.payment?.transactionStatus === "COMPLETED"
                  ? "success"
                  : item.payment?.transactionStatus === "FAILED"
                  ? "error"
                  : "warning"
              }
              size="small"
              sx={{ mr: 1 }}
            />
            {item.payment?.transactionStatus === "COMPLETED" && (
              <Button
                size="small"
                variant="outlined"
                sx={{ mt: 1 }}
                onClick={() => {
                  setSelectedBooking(item);
                  setPaymentDialogOpen(true);
                }}
              >
                View Payment Details
              </Button>
            )}
          </Paper>
        ))
      ) : (
        <Typography>No bookings found</Typography>
      );
    })()}
  </>
)} */}




{!bookingLoading && bookingHistory && (
  <>
    <Typography variant="subtitle1" gutterBottom>
      Bookings ({bookingFilter})
    </Typography>

    {filteredSortedBookings.length ? (
      filteredSortedBookings.map(item => (
        <Paper key={item._id} sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle2">{item.movieName}</Typography>
          <Typography variant="body2">
            {item.showDate} • {item.showTime}
          </Typography>
          <Typography variant="body2">{item.theatreName}</Typography>
          <Typography variant="body2">
            Amount: ₹{item.payment?.totalAmount || 0}
          </Typography>

          <Chip
            label={item.payment?.transactionStatus}
            color={
              item.payment?.transactionStatus === "COMPLETED"
                ? "success"
                : item.payment?.transactionStatus === "FAILED"
                ? "error"
                : "warning"
            }
            size="small"
            sx={{ mr: 1 }}
          />

          {item.payment?.transactionStatus === "COMPLETED" && (
            <Button
              size="small"
              variant="outlined"
              sx={{ mt: 1 }}
              onClick={() => {
                setSelectedBooking(item);
                setPaymentDialogOpen(true);
              }}
            >
              View Payment Details
            </Button>
          )}
        </Paper>
      ))
    ) : (
      <Typography>No {bookingFilter.toLowerCase()} bookings found</Typography>
    )}
  </>
)}










                    </CardContent>
                  </Card>
                </TabPanel>
              </Grid>



            </Grid>
          </Grid>
        </Grid>
      )}


      <Dialog
        open={paymentDialogOpen}
        onClose={() => setPaymentDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Payment Details
          <IconButton
            onClick={() => setPaymentDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
  {selectedBooking && (
    <Stack spacing={2}>
      <Typography><b>Status:</b> {selectedBooking.payment?.transactionStatus || "N/A"}</Typography>
      <Typography><b>Transaction ID:</b> {selectedBooking.payment?.transactionId || "N/A"}</Typography>
      <Typography><b>Merchant Txn ID:</b> {selectedBooking.payment?.merchantTransactionId || "N/A"}</Typography>

      {/* Dynamically print paymentInstrument fields */}
      {selectedBooking.payment?.paymentInstrument && (
        <>
          <Typography><b>Payment Instrument Details:</b></Typography>
          {Object.entries(selectedBooking.payment.paymentInstrument).map(([key, value]) => (
            <Typography key={key}>
              <b>{key.replace(/([A-Z])/g, " $1")}:</b> {value || "N/A"}
            </Typography>
          ))}
        </>
      )}

      <Typography><b>Payment Method:</b> {selectedBooking.payment?.paymentMethod || "N/A"}</Typography>
      <Typography><b>Payment Mode:</b> {selectedBooking.payment?.paymentMode || "N/A"}</Typography>
      <Typography><b>Amount:</b> ₹{selectedBooking.payment?.totalAmount || 0}</Typography>
    </Stack>
  )}
</DialogContent>

      </Dialog>
    </Paper>



  );




}





const TabPanel = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};
export default UserProfile;
